module.exports = __webpack_public_path__ + "img/joel-headshot@2x.f74354b9.png";